import './configs';
import 'bootstrap';
//import './vendor/prefixfree';
import './vendor/jquery/notify.min';
//import './vendor/jquery/bootstrap-notify.min';

import './vendor/jquery/nice-select/js/jquery.nice-select.min';

import './vendor/datepicker/datepicker';
import './vendor/datepicker/datepicker.ru-RU';

import './vendor/bootstrap-select/js/bootstrap-select.min';
import './vendor/bootstrap-select/js/i18n/defaults-ru_RU.min';

import './helpers';

import * as Modules from '../modules';
import * as Parts from '../parts';
